import React from 'react';
import Navigation from '../Shared/Navigation/Navigation';

const Pay = () => {
    return (
        <>
        <Navigation></Navigation>
        <div>
            <h1>Pay is Comming Soon</h1>
        </div>
        </>
    );
};

export default Pay;